import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

export function NotFound({ children }: { children?: React.ReactNode }) {
  const { t } = useTranslation()

  return (
    <div className="min-w-0 flex-1 p-8 flex flex-col items-center justify-center gap-4 text-center">
      <div className="text-6xl font-bold text-gray-200 dark:text-gray-700 select-none">404</div>
      <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100">
        {t('errors.notFoundTitle')}
      </h2>
      <p className="text-gray-500 dark:text-gray-400 max-w-sm">
        {children ?? t('errors.notFoundDescription')}
      </p>
      <div className="flex gap-3 flex-wrap justify-center mt-2">
        <button
          onClick={() => window.history.back()}
          className="px-4 py-2 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded-md text-sm hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
        >
          {t('errors.errorBoundary.backButton')}
        </button>
        <Link
          to="/"
          className="px-4 py-2 bg-cyan-600 hover:bg-cyan-700 text-white rounded-md text-sm font-medium transition-colors"
        >
          {t('errors.errorBoundary.homeButton')}
        </Link>
      </div>
    </div>
  )
}
